import SimpleEditor from './SimpleEditor';

export default function NoteEditor({ note, updateDocument, setTitle }) {
  return (
    <div className="flex h-full flex-col">
      <div className="mx-auto w-full max-w-3xl px-6 py-10 pb-2">
        <input
          className="w-full bg-transparent text-4xl font-bold text-foreground outline-none placeholder:text-muted-foreground"
          value={note.title}
          onChange={(e) => setTitle(note.id, e.target.value)}
          placeholder="Untitled note"
        />
      </div>
      <div className="flex-1">
        <SimpleEditor content={note.document} onChange={(doc) => updateDocument(note.id, doc)} />
      </div>
    </div>
  );
}
